/* eslint-disable @nx/enforce-module-boundaries */
import {
  isDocRef,
  ISoftDelete,
  TypeGuard,
  type DocumentReference,
  type Timestamp,
} from '@principle-theorem/shared';
import { type IBrand } from '@principle-theorem/principle-core/interfaces';
import { type IPractice } from '@principle-theorem/principle-core/interfaces';
import { type IPracticeMigration } from './practice-migration';
import { type PmsType } from './migration-toolkit';

export enum MigrationUploadSessionStatus {
  Pending = 'pending',
  Uploading = 'uploading',
  Uploaded = 'uploaded',
  Converting = 'converting',
  Complete = 'complete',
  Failed = 'failed',
  Cancelled = 'cancelled',
}

export interface IMigrationUploadSession extends ISoftDelete {
  practiceRef: DocumentReference<IPractice>;
  brandRef: DocumentReference<IBrand>;
  migrationRef: DocumentReference<IPracticeMigration>;
  pmsType?: PmsType;
  status: MigrationUploadSessionStatus;
  uploadedAt?: Timestamp;
  convertedAt?: Timestamp;
  uploadPath: string;
  convertedPath?: string;
  errorMessage?: string;
  backupManifestPath?: string;
  convertedCsvPaths?: string[];
  conversionVm?: IConversionVmInfo;
  sourcePath?: string;
  conversionSourcePath?: string;
}

export interface IConversionVmInfo {
  instanceName: string;
  zone: string;
  projectId: string;
  externalIp: string;
}

export interface ISyncFromUploadSessionRequest {
  migrationRef: DocumentReference<IPracticeMigration>;
  sessionRef: DocumentReference<IMigrationUploadSession>;
}

export const isSyncFromUploadSessionRequest =
  TypeGuard.interface<ISyncFromUploadSessionRequest>({
    migrationRef: isDocRef,
    sessionRef: isDocRef,
  });

export interface ISyncFromUploadSessionResponse {
  jobsCreated: number;
  csvPaths: string[];
}
